import { BaseCemsReadingComponent } from "./reading";
import { Options } from "vue-class-component";
import { ChartConfiguration, ChartOnclick } from "@cems-eco/core/src/models";
import { ReadingComponent } from "./interfaces";
import { getRandomColor } from "@cems-eco/core/src/utils/helper";

@Options({
  props: {
    equipment: Object,
    type: String
  },
})
export class DemoReadingComponent extends BaseCemsReadingComponent implements ReadingComponent {


  async created() {
    this.setChartConfig();
    this.setChartOneMinConfig();
  }

  async mounted() {
    const scope = this;
    setInterval(() => {
      scope.reading();
    }, 1000);
  }
  
  getRandomNumber(total) {

    const randomNumbers: any = [];

    for (var i = 0; i < total; i++) {
      const randomNumber: any = Math.floor(Math.random() * (100));
      randomNumbers.push(randomNumber);
    }
    return randomNumbers;
  }

  fetch(){}


  setChartConfig() {
    // Dust, CO, NOx, SO
    this.datasets  = this.equipment.sensors.map((sensor) =>  {
      return {
        id: sensor.id + sensor.name,
        label: sensor.name,
        borderColor: sensor.color,
        fill: false,
        data: this.getRandomNumber(10),

      }
    })
    this.config = {
      type: 'line',
      data: {
        labels: [
          "7:00:00 pm",
          "7:30:00 pm",
          "8:00:00 pm",
          "8:30:00 pm",
          "9:00:00 pm",
          "9:30:00 pm",
          "10:00:00 pm",
          "10:30:00 pm",
          "11:00:00 pm",
          "11:30:00 pm",
        ],
        datasets: this.datasets,
      },

      // Configuration options go here
      options: {
        responsive: true,
        aspectRatio: 10 / 4,
        maintainAspectRatio: this.type == 'basic',
        layout: {
          padding: {
            top: 7,
            right: 7,
          }
        },
        legend: {
          // display: this.type == 'advance',
          position: 'bottom',
          labels: {
            // fontColor: this.type == 'basic' ? '#fff' : '#000'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              display: true,
              fontColor: "#BEBEBE",
              fontSize: 13,
              padding: 12
            },
            gridLines: {
              borderDash: [8, 4],
              zeroLineWidth: 0,
              drawBorder: false,
              display: this.type == 'advance'
            },
          }],
          xAxes: [{
            ticks: {
              display: true,
              fontColor: "#BEBEBE",
              fontSize: 13,
            },
            gridLines: {
              borderDash: [8, 4],
              zeroLineWidth: 0,
              drawBorder: false,
              display: this.type == 'basic',
            },
          }]
        }
      },
    };
  }

  setChartOneMinConfig() {
    this.oneMinDatasets = [{
      id: "1",
      label: "DUST",
      borderColor: getRandomColor(4),
      fill: false,
      data: [90, 80, 70, 80, 90, 80, 70, 80, 90, 80,],
    }];
    this.oneMinConfig = {
      type: 'line',
      data: {
        labels: [
          "7:00:00 pm",
          "7:30:00 pm",
          "8:00:00 pm",
          "8:30:00 pm",
          "9:00:00 pm",
          "9:30:00 pm",
          "10:00:00 pm",
          "10:30:00 pm",
          "11:00:00 pm",
          "11:30:00 pm",
        ],
        datasets: this.oneMinDatasets,
      },

      // Configuration options go here
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              fontColor: "#BEBEBE",
              fontSize: 13,
              padding: 12
            },
            gridLines: {
              borderDash: [8, 4],
              zeroLineWidth: 0,
              drawBorder: false,
            },
          }],
          xAxes: [{
            ticks: {
              fontColor: "#BEBEBE",
              fontSize: 13,
            },
            gridLines: {
              display: false,
            },
          }]
        }
      },
    };
  }

  reading() {
    this.equipment.sensors = this.equipment.sensors.map((sensor) => {
      return { ...sensor, value: Number(Math.floor(Math.random() * 10) + 1).toFixed(2), alarm: !sensor.alarm};
    })
  }

  async min30Onclick(res: ChartOnclick) {
    const { id, label, borderColor, fill, data } = res.dataset;

    this.oneMinDatasets = [
      { id, label, borderColor, fill, data },
    ];
    this.oneMinConfig.data.datasets = this.oneMinDatasets;
    this.isShowOneMin = true;
  }

  backTo30min() {
    this.isShowOneMin = false;
  }
}

